import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useSettingsContext } from '@eversports/react-app-base/SettingsContext'

import ClockIcon from '../../../../../assets/icons/clock.svg'
import { formatTime } from '../../../../../helpers/format-time'

interface Props {
  start: string
  end: string
}

const ParticipationTime = ({ start, end }: Props) => {
  const { language } = useSettingsContext()
  const startTime = formatTime(language, start)
  const endTime = formatTime(language, end)

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Icon src={ClockIcon} color="midnight" size="small" />
      <Text sx={{ color: 'midnight' }}>
        {startTime} - {endTime}
      </Text>
    </Stack>
  )
}

export default ParticipationTime
